import { html, LitElement, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

import { NAMESPACE } from "@/constants";
import { genRandSeed } from "@/utils";

import type { DividerPart, SbDividerProps as Props } from "./divider.types";

/**
 * Visually separates sections, accepting an optional inline label.
 *
 * @part divider - rtg-field-separator: root
 */
@customElement("sb-divider")
export class SbDivider extends LitElement implements Props {
  static readonly ROOT = "divider";

  static readonly TAG = `${NAMESPACE}-${SbDivider.ROOT}`;

  static readonly PARTS: Record<DividerPart, string> = { root: SbDivider.ROOT };

  /* ------------------------------------------------------------ */

  /**
   * Substring used in generated part IDs.
   */
  @property({ type: String })
  seed = genRandSeed();

  /**
   * Custom ID used as the root part ID and as the base of subpart IDs.
   */
  @property({ type: String, attribute: "custom-id" })
  customId?: string;

  /**
   * Optional text used as the divider label.
   */
  @property({ type: String })
  label?: string;

  /* ------------------------------------------------------------ */

  protected createRenderRoot() {
    return this;
  }

  /* ------------------------------------------------------------ */

  get rootId() {
    return this.customId ?? `${SbDivider.TAG}-${this.seed}`;
  }

  /* ------------------------------------------------------------ */

  render() {
    return html`
      <rtg-field-separator id="${this.rootId}" part="${SbDivider.PARTS.root}">
        ${this.label ?? nothing}
      </rtg-field-separator>
    `;
  }
}
